import { handleGenericApiError } from "app/api/error";
import { addLoading, removeLoading } from "./loading";
import Report from "app/api/report";

export const ACTION_SAVE_ALL_REPORTS_SOLICITATION_JOB =
  "report:ACTION_SAVE_ALL_REPORTS_SOLICITATION_JOB";
export const ACTION_SAVE_DAILY_REPORTS_SOLICITATION_JOB =
  "report:ACTION_SAVE_DAILY_REPORTS_SOLICITATION_JOB";
export const ACTION_SAVE_REPORTS = "report:ACTION_SAVE_REPORTS";
export const ACTION_SAVE_HISTORY = "report:ACTION_SAVE_HISTORY";

export const fetchAllReportSolicitationJob = params => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await Report.fetchAllReportSolicitationJob(params);
    dispatch({ type: ACTION_SAVE_ALL_REPORTS_SOLICITATION_JOB, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchAllDailyReportSolicitationJob =
  params => async dispatch => {
    dispatch(addLoading());
    try {
      let data = await Report.fetchAllDailyReportSolicitationJob(params);
      dispatch({
        type: ACTION_SAVE_DAILY_REPORTS_SOLICITATION_JOB,
        payload: data,
      });
    } catch (err) {
      handleGenericApiError(err);
    } finally {
      dispatch(removeLoading());
    }
  };

export const fetchAllDownloads = params => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await Report.fetchAllDownloads(params);
    dispatch({ type: ACTION_SAVE_REPORTS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchExtractionHistory = params => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await Report.fetchExtractionHistory(params);
    dispatch({ type: ACTION_SAVE_HISTORY, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchAllCSVReport = IdReport => async dispatch => {
  dispatch(addLoading());
  try {
    await Report.fetchCSVReport(IdReport);
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchCSVSolicitation = body => async dispatch => {
  dispatch(addLoading());
  try {
    return await Report.fetchCSVSolicitation(body);
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};
